class StickyBlocks {
    panels = Array.from(document.querySelectorAll('.section-item'));
    panelsY = [];
    isSafari: boolean;
    addHeight = 0;

    constructor() {
        if (!this.panels)
            return;

        this.panels.forEach((element:HTMLElement) => {
            this.panelsY.push(element.offsetTop)
        })

        this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        window.addEventListener('load', this.setTop.bind(this));
        window.addEventListener('load', this.setPosition.bind(this));
        if (window.outerWidth >= 576 && !this.isSafari) {
            window.addEventListener('resize', this.setTop.bind(this));
        }
        window.addEventListener('scroll', this.setPosition.bind(this));
    }

    getTop() {
        let top = 70;
        if (window.outerWidth >= 1151 && window.outerWidth <= 1550) {
            top = 48;
        } else if (window.outerWidth >= 992 && window.outerWidth <= 1150) {
            top = 100;
        } else if (window.outerWidth >= 576 && window.outerWidth <= 991) {
            top = 75;
        } else if (window.outerWidth >= 350 && window.outerWidth <= 575) {
            top = 70;
        } else if (window.outerWidth <= 349) {
            top = 52;
        }
        return top
    }

    setPosition() {
        let y = window.scrollY + this.getTop();
        for (var i = 0; i < this.panels.length; i++) {
            if ((i === this.panels.length - 1) ||
                (y >= this.panelsY[i] && y <= this.panelsY[i + 1])
            ) {
                break;
            }
        }
        this.panels.forEach((item:HTMLElement, index) => {
            item.style.setProperty("--pos", "sticky")
            if (index + 1 < i)
                item.style.setProperty("--pos", "unset")
        });
    }

    setTop() {
        this.panels.forEach((item:HTMLElement) => {
            let {height} = item.getBoundingClientRect();
            let top = (document.documentElement.clientHeight) - height + this.addHeight;

            if (top < 0 || !this.isSafari) {
                item.style.top = ((top < 0) ? top : this.getTop()) + 'px';
            } else {
                item.style.top =  this.getTop() + 'px';
            }
        });
    }
}

export default StickyBlocks;
